const IssueTypes = {
	UPDATE_LEVEL: 0,
	CONTRACT: 1,
	MISSION: 2,
	ONBOARD: 3, 
	CONTRACT_CONFIRMED_DATES_MISMATCH: 45,
	OTHER: 909
}

export default  IssueTypes